import React, { useMemo, useRef, useEffect } from 'react'

import { useTab } from '../../tabs/hooks'

import styles from './MobileBaseLayout.module.css'

const MobileBaseLayout = ({ children, title, basePath }) => {
  const [menuIsOpen, openMenu] = useTab(`${basePath}/menu`)
  const [_, closeMenu] = useTab(basePath)
  const container = useRef(null)

  const onMenuClick = useMemo(() => (menuIsOpen ? closeMenu : openMenu), [
    menuIsOpen,
    openMenu,
    closeMenu,
  ])

  useEffect(() => {
    container.current.height = window.innerHeight
  }, [])

  return (
    <div className={styles.container} ref={container}>
      <i
        className={'fas fa-bars ' + styles.headerMenuButton}
        onClick={onMenuClick}
      ></i>
      <div className={styles.header}>
        <h1 className={styles.headerTitle}>
          {title} <small>Mobile</small>
        </h1>
      </div>
      {children}
    </div>
  )
}

export default MobileBaseLayout
